import React, { useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";
import states from "../data/india_states.json";

export default function Register() {
  const nav = useNavigate();

  const [form, setForm] = useState({});
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [loading, setLoading] = useState(false);

  function set(key, val) {
    setForm({ ...form, [key]: val });
  }

  async function submit(e) {
    e.preventDefault();

    try {
      setLoading(true);

      await api.post("/auth/signup", {
        ...form,
        state: selectedState,
        district: selectedDistrict,
      });

      alert("✅ Registration successful");
      nav("/login");
    } catch (err) {
      alert("❌ Registration failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={page}>
      <div style={overlay}>
        <form onSubmit={submit} style={card}>
          
          {/* LOGO */}
          <div style={{ textAlign: "center" }}>
            <img src="/logo.png" alt="EduAt10" style={logo} />
          </div>

          <h2 style={title}>Create Account</h2>

          {/* INPUT GRID */}
          <div style={grid}>
            <input
              placeholder="Full Name"
              required
              style={input}
              onChange={(e) => set("name", e.target.value)}
            />

            <input
              placeholder="Email"
              type="email"
              required
              style={input}
              onChange={(e) => set("email", e.target.value)}
            />

            <input
              placeholder="Phone"
              required
              style={input}
              onChange={(e) => set("phone", e.target.value)}
            />

            <input
              placeholder="Password"
              type="password"
              required
              style={input}
              onChange={(e) => set("password", e.target.value)}
            />

            <select
              value={selectedState}
              onChange={(e) => {
                setSelectedState(e.target.value);
                setSelectedDistrict("");
              }}
              required
              style={input}
            >
              <option value="">Select State</option>
              {Object.keys(states).map((s) => (
                <option key={s}>{s}</option>
              ))}
            </select>

            <select
              value={selectedDistrict}
              onChange={(e) => setSelectedDistrict(e.target.value)}
              required
              style={input}
            >
              <option value="">Select District</option>
              {(states[selectedState] || []).map((d) => (
                <option key={d}>{d}</option>
              ))}
            </select>
          </div>

          {/* BUTTON */}
          <button type="submit" style={btn} disabled={loading}>
            {loading ? "Please wait..." : "Register"}
          </button>

          {/* LOGIN LINK */}
          <p style={loginText}>
            Already have an account?{" "}
            <span style={loginLink} onClick={() => nav("/login")}>
              Login
            </span>
          </p>
        </form>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const page = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlay = {
  minHeight: "100vh",
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 20,
};

const card = {
  width: "100%",
  maxWidth: 500,
  background: "#ffffff",
  padding: 30,
  borderRadius: 16,
  boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
};

const logo = {
  width: 110,
  marginBottom: 10,
};

const title = {
  textAlign: "center",
  marginBottom: 20,
};

const grid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 12,
};

const input = {
  padding: 12,
  borderRadius: 8,
  border: "1px solid #d1d5db",
  fontSize: 14,
  outline: "none",
  width: "100%",
};

const btn = {
  marginTop: 20,
  padding: 14,
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 10,
  fontWeight: "600",
  cursor: "pointer",
  width: "100%",
};

const loginText = {
  marginTop: 15,
  textAlign: "center",
  fontSize: 14,
};

const loginLink = {
  color: "#2563eb",
  cursor: "pointer",
  fontWeight: "600",
};